import clsx from 'clsx';

import { Typography } from './typography';

interface TagProps {
  className?: string;
  icon?: string;
  text: string;
}

export function Tag({ className, icon, text }: TagProps) {
  return (
    <div
      className={clsx(
        'flex h-6 w-fit items-center justify-center gap-1 whitespace-nowrap rounded-full px-2',
        className,
      )}
    >
      {icon && <img src={icon} alt="" />}
      <Typography variant="small1" className="!text-fx-neutral-600 px-1">
        {text}
      </Typography>
    </div>
  );
}
